import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var $: any;

@Component({
  selector: "app-app-manager-edit",
  templateUrl: "./app-manager-edit.component.html",
  styleUrls: ["./app-manager-edit.component.css"],
})
export class AppManagerEditComponent implements OnInit {
  public data: any = {
    active: 1,
    id: 0,
    name: "",
    password: "",
    userName: "",
  };

  public isCreate = false;

  private id = 0;

  public fakePwd = "*********";

  constructor(
    private route: ActivatedRoute,
    private HttpService: HttpService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });

    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }

    $("input[name=fake-password]").on("focus", function () {
      console.log(111);
      $(this).hide();
      $("input[name=password]").show();
      $("input[name=password]").focus();
    });
  }

  public submit() {
    let data = this.data;
    delete data.createdBy;
    delete data.createdTime;
    delete data.updatedBy;
    delete data.updatedTime;

    this.HttpService.postData(API.appManager, this.data).then((res) => {
      if (res.status.code == 0) {
        history.go(-1);
      }
    });
  }

  private getData() {
    this.HttpService.getData(API.appManager + "/" + this.id).then((res) => {
      if (res.status.code == 0) {
        this.data = res.data;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/app-manager-edit/app-manager-edit.component.ts